export default __webpack_public_path__ + "static/media/trener13.75699dfb.png";